import { Block } from 'ui-kit/blocks'
import { Heading } from 'ui-kit/typography'
import { Actions, Link } from 'ui-kit/actions'
import { Picture } from 'ui-kit/picture'
import { DOCS_LINK } from 'routes/constants'
import { BookCalendlyLink } from 'routes/components/Shared'
import HeroMobImage1x from './hero-mob@1x.png'
import HeroMobImage2x from './hero-mob@2x.png'
import HeroDeskImage1x from './hero-desk@1x.png'
import HeroDeskImage2x from './hero-desk@2x.png'
import classes from './LandingHero.module.scss'

export const LandingHero = () => {
  return (
    <Block
      as={'section'}
      variant={'shadowMob'}
      divider={'mobile'}
      className={classes.section}
    >
      <Block
        variant={'solidMob'}
        pad={'baseMob'}
        r={'md'}
        className={classes.content}
      >
        <div className={classes.heading}>
          <Heading
            as={'h1'}
            size={'xxl'}
            balance
            center
            className={classes.title}
          >
            Build every single integration your customers need with AI
          </Heading>

          <Actions className={classes.actions}>
            <BookCalendlyLink type={'primary'} className={classes.button}>
              Book a demo
            </BookCalendlyLink>
            <Link
              type={'secondary'}
              href={DOCS_LINK}
              target={'_blank'}
              asPageButton
              className={classes.button}
            >
              Read the docs
            </Link>
          </Actions>
        </div>

        <div className={classes.visual}>
          <Picture
            className={classes.image}
            mobSrc1x={HeroMobImage1x.src}
            mobSrc2x={HeroMobImage2x.src}
            deskSrc1x={HeroDeskImage1x.src}
            deskSrc2x={HeroDeskImage2x.src}
            width={972}
            height={886}
            alt='Build integration your customers need with AI'
            deskBreakpoint={576}
            fetchPriorityHigh
          />
        </div>
      </Block>
    </Block>
  )
}
